module.exports = __webpack_public_path__ + "img/20.8c9d82a5.png";